import React from 'react'

export function ServicesErrorState() {
  return (
    <div className="p-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-red-600 mb-2">Error Loading Services</h2>
        <p className="text-gray-600">Unable to load services data. Please try again later.</p>
      </div>
    </div>
  )
}
